
import env from '@/config/env.js'
const bootenv = env()
let urlPath = {
  DEV: {
    indexBanner: {
      mediaId: "84",
      advIds: "25,26,27,28,29"
    }
  },
  TEST: {
    indexBanner: {
      mediaId: "84",
      advIds: "25,26,27,28,29"
    }
  },
  TEST2: {
    indexBanner: {
      mediaId: "84",
      advIds: "25,26,27,28,29"
    }
  },
  STAGE: {
    indexBanner: {
      mediaId: "1",
      advIds: "1,2,3,4,5"
    }
  },
  PRODUCT: {
    indexBanner: {
      mediaId: "1",
      advIds: "1,2,3,4,5"
    }
  }
};

export default urlPath[bootenv];
